module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI2ZmZmZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSIyIi8+DQogICAgICAgIDxjaXJjbGUgY3g9IjUuNSIgY3k9IjUuNSIgcj0iMS41Ii8+DQogICAgICAgIDxwYXRoIGQ9Ik0xOCAxMmwtNS01TDIgMTgiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-gallery-small-white.svg
// module id = m4mk
// module chunks = 1